import { TRIAGE_ORDER } from '../constants/triage.constants';
import type { AssessedCondition, Triage } from '../types/overall-assessment.types';

export const INCONCLUSIVE_SEVERITY = 'inconclusive';

/*  The note shown on the right of a row whose assessment was stopped early. */
export const STOPPED_EARLY_NOTE_TOKEN = 'app.assessment_mode.risk_assessment.inconclusive.stopped_early';

export const normalizeTriage = (value: unknown): Triage => {
  return TRIAGE_ORDER.includes(value as Triage) ? (value as Triage) : 'none';
};

export const riskAssessmentSection = (condition: AssessedCondition): Triage => {
  if (condition.severity === INCONCLUSIVE_SEVERITY) return 'inconclusive';
  return normalizeTriage(condition.triage_recommendation);
};

export const isStoppedEarly = (condition: AssessedCondition): boolean => {
  return condition.assessment_state === 'partial'
    && condition.severity === INCONCLUSIVE_SEVERITY;
};
